<div class="modal fade" id="edit-draft-modal" role="dialog" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content rounded rounded-900 shadow-modal">
      <div class="modal-header">
        <h5 class="modal-title">{{'EDIT_DRAFT' | translate}}
        </h5>
        <button (click)="closeModal('edit-draft-modal')" class="close">
          <svg class="icon">
            <use xlink:href="assets/svg/sprite.svg#it-close"></use>
          </svg>
        </button>
      </div>
      <div class="modal-body" *ngIf="draft">
        <app-edit-draft *ngIf="activeModal ==='edit-draft-modal'" (callbackAction)="onEditedForm($event)"
                        [draft]="draft"></app-edit-draft>
      </div>


      <div class="modal-footer">
        <button (click)="closeModal('edit-draft-modal')" class="btn btn-outline-secondary btn-sm" type="button">
          {{'BUTTON.CLOSE'|translate}}
        </button>
        <button (click)="onSaveDraft()"
                [disabled]="!editDraftForm?.dirty || !editDraftForm?.valid || editDraftForm?.pending"
                class="btn btn-primary btn-sm"
                type="button">
          {{'BUTTON.CONFIRM'|translate}}
          <span *ngIf="editDraftForm?.pending" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>
        </button>
      </div>
    </div>
  </div>
</div>
